import url_ from "asset-data:assets/galleries/ua-2021-12-09/L1001041-bw_afa29ba057__400.jpg";
export const url = url_;